<template>
  <section class="hero is-danger">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">401: Unauthorized</h1>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "error_unauthorized"
};
</script>
